import Component from '../abstracts/Component';

export default class FooterComponent extends Component{
  static get SELECTORS(){
    const hasSubMenu = 'has-sub-menu';

    return {
      hasSubMenuSel : `.${hasSubMenu}`,
      hasSubMenuNavigationLinkSel : `.${hasSubMenu} > a`
    }
  }

  constructor(){
    super();
    this.s = FooterComponent.SELECTORS;
  }

  /**
   * Entry point of the component
   *
   * TODO: 1) Review condition on $(window).width with a responsive implementation
   */
  bindInitEvent() {


    if ($(window).width() < 992) {

      this.moduleLoader.loadBootstrapJsComponentAndExecute("collapse",
        (module) => {
          // Initialize data toggle
          this.log('Collapse initialized');
        },
        (error) => {
          console.error("Failed to load the bootstrap component", error.stack);
      });

    }

  }

  render() {
    super.render();
    //this.bindInitEvent();
  }
}
